import { CertificateForm } from 'front-office/components/released-services/form';
import { ReleasedService } from 'shell/models/certificate';

export const updateRequestTransformer = (
  formValues?: CertificateForm
): Partial<ReleasedService> => {
  const data: Partial<ReleasedService> = {
    modalitaRilascio: formValues?.releaseMode?.id
      ? {
          key: formValues?.releaseMode?.id
            ? {
                codiceModalitaRilascio: formValues?.releaseMode?.id?.toString() || undefined,
              }
            : undefined,
        }
      : undefined,
    importoBollo: formValues?.stamp,
    importoDirittiSegreteria: formValues?.secretary,
    importoDirittiStatoCivile: formValues?.civilStatus,
    importoDirittiFissi: formValues?.fixed,
    codiceOperatoreRilascio: formValues?.emitted,
    tipoPagamento: formValues?.payment,
    codiceServizioRilascio: formValues?.service,
  };

  if (formValues?.applicantReleaseReason) {
    data.richiedente = {
      motivoRilascio: formValues?.applicantReleaseReason,
    };
  }

  return data;
};
